import { AppState } from "../store/AppState";
import * as ActionTypes from "../actions/actionTypes";
import authentication from "./authenticationReducer";
import errors from "./errorsReducer";
import inProgress from "./inProgressReducer";
import logoutCompleted from "./logoutCompletedReducer";
import pendingAuthentication from "./pendingAuthenticationReducer";
import { AppAction } from "../actions/actionTypes";
import licenses from "./licensesReducer";

/**
 * Combined reducer for working independently for different branches of the state tree.
 * This is not exposed directly, but only via root reducer that may work on the
 * whole state.
 */

const appReducer: (state: any, action: AppAction) => AppState = (
  state,
  action
) =>
  ({
    authentication: authentication(state?.authentication, action),
    licenses: licenses(state?.licenses, action),
    errors: errors(state?.errors, action),
    inProgress: inProgress(state?.inProgress, action),
    logoutCompleted: logoutCompleted(state?.logoutCompleted, action),
    pendingAuthentication: pendingAuthentication(
      state?.pendingAuthentication,
      action
    ),
  } as AppState);

const rootReducer = (
  state?: AppState,
  action: ActionTypes.AppAction = { type: "NOOP" }
): AppState => {
  return appReducer(
      action.type === ActionTypes.CLEAR_ALL
          ? undefined
          : state,
      action)
  ;
};

export default rootReducer;
